const initialState = {
  list: [],
  loading: 'idle',
  selectedDepartment: {},
};

export default initialState;
